import React from "react";
import "./ImageContainer.css";

const ImageContainer = ({ src, title }) => {
  return (
    <>
    <div className="mb-3">
      <div className="image-container d-flex justify-content-center mb-2">
        <img src={src} alt={title} />
      </div>
      <h4 className="image-title text-center">{title}</h4>
      </div>
    </>
  );
};

export default ImageContainer;
